import { render } from "./PostsPage.vue?vue&type=template&id=728099ee"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"

import "./PostsPage.vue?vue&type=style&index=0&id=728099ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__